import { Box, Card, CardContent, Typography } from "@mui/material";

// TODO: define content for this card
export function PlaceholderCard() {
  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height={300}
        >
          <Typography color="text.disabled" variant="body2">
            Em breve
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
